import { selectIsBrokerAvailable } from './selectIsBrokerAvailable';
import { selectIsPartnerRewardsRegistrationStatusAvailable } from './selectIsPartnerRewardsRegistrationStatusAvailable';
import { IApplicationState } from '../../types/redux';

export const selectIsBrokerVisible = (state: IApplicationState) => {
  const isRegistrationStatusAvailable = selectIsPartnerRewardsRegistrationStatusAvailable(state);
  const isBrokerAvailable = selectIsBrokerAvailable(state);

  return isRegistrationStatusAvailable || isBrokerAvailable;
};
